import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#151515",
      d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8.016 34.447V13.504h4.24v20.943zM14.375 34.447V13.504h5.3q1.37 0 2.534.233a5.7 5.7 0 0 1 2.055.827q.893.595 1.37 1.642.48 1.047.479 2.728 0 1.266-.362 2.159-.362.891-1.034 1.409-.672.516-1.655.698 1.214.18 2.043.827.827.647 1.24 1.706.414 1.06.415 2.56 0 1.578-.401 2.741-.402 1.163-1.177 1.913-.776.75-1.913 1.125t-2.637.375zm4.266-12.488h1.06q1.112 0 1.68-.324.57-.323.79-.982.22-.66.22-1.616t-.324-1.538a1.86 1.86 0 0 0-.983-.84q-.66-.26-1.667-.26h-.776zm0 9.488h1.19q1.602 0 2.21-.801t.608-2.405q0-1.24-.285-1.977t-.918-1.086q-.633-.35-1.693-.35H18.64zM33.479 34.756q-2.12 0-3.361-.892-1.242-.893-1.772-2.534-.53-1.642-.53-3.813V20.51q0-2.25.543-3.878.543-1.63 1.9-2.509 1.359-.879 3.685-.879 2.25 0 3.555.75a4.28 4.28 0 0 1 1.875 2.12q.569 1.371.569 3.258v1.215H35.78v-1.473q0-.828-.104-1.461-.103-.633-.478-.995-.375-.363-1.202-.363-.854 0-1.241.44-.39.44-.492 1.125a10 10 0 0 0-.103 1.46v9.283q0 .88.155 1.577.155.698.582 1.086t1.228.388 1.241-.414q.439-.412.608-1.125a7 7 0 0 0 .168-1.616v-2.223h-2.043V23.69h5.895v10.756h-2.792l-.259-1.887a3.85 3.85 0 0 1-1.24 1.577q-.828.62-2.224.62"
    }, null, -1)
  ]))]))
}
export default { render: render }